module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_04.9d39d439.jpg";